export var renderStructureData = function (itemUrls) { return ({
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: itemUrls.map(function (url, position) { return ({
        '@type': 'ListItem',
        position: position + 1,
        url: url,
    }); }),
}); };
